// extracted by mini-css-extract-plugin
export default {"news":"News_news__pDGJI","media":"News_media__hAynJ","title":"News_title__hrfSb","announce":"News_announce__fRdPj"};